module.exports = __webpack_public_path__ + "img/Lc.6bc69d9c.png";